import { render, staticRenderFns } from "./CompanyMarketData.vue?vue&type=template&id=2fbfcd98"
import script from "./CompanyMarketData.vue?vue&type=script&lang=js"
export * from "./CompanyMarketData.vue?vue&type=script&lang=js"
import style0 from "./CompanyMarketData.vue?vue&type=style&index=0&id=2fbfcd98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports